import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputPrimecapComponent } from './input-primecap.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconsPrimecapModule } from '../icons-primecap/icons-primecap.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import { NgxCurrencyDirective } from "ngx-currency";

@NgModule({
  declarations: [
    InputPrimecapComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
		ReactiveFormsModule,
    IconsPrimecapModule,
    MatInputModule,
    MatIconModule,
		MatTooltipModule,
		MatIconModule,
		NgxMaskDirective,
		NgxCurrencyDirective
  ],
  exports: [
    InputPrimecapComponent
  ],
  providers: [
    provideEnvironmentNgxMask()
  ]
})
export class InputPrimecapModule { }
